import { useWorkspaceDetails } from '@air/plugin-ui';

import { useURLWorkspaceId } from '~/hooks/url/useURLWorkspaceId';

export const useSelectedWorkspaceDetails = () => {
  const selectedWorkspaceId = useURLWorkspaceId();
  const {
    generalLibraryColor,
    generalLibraryDescription,
    generalLibraryIcon,
    generalLibraryTitle,
    workspace: selectedWorkspace,
  } = useWorkspaceDetails({ workspaceId: selectedWorkspaceId });

  return {
    generalLibraryColor,
    generalLibraryDescription,
    generalLibraryIcon,
    generalLibraryTitle,
    selectedWorkspace,
    selectedWorkspaceId,
  };
};
